import script from "./vmsCustomAttributeGroupChange.vue?vue&type=script&lang=js"
export * from "./vmsCustomAttributeGroupChange.vue?vue&type=script&lang=js"

import "./vmsCustomAttributeGroupChange.vue?vue&type=style&index=0&id=e40a22a8&lang=css"
import "./vmsCustomAttributeGroupChange.vue?vue&type=style&index=1&id=e40a22a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e40a22a8"]])

export default __exports__